import { Inject, Injectable } from '@angular/core';
import { AbstractControl, FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';

import { DataConfiguration, DynamicFormBuilderService as Builder } from '@assess/shared/dynamic-components';

import { OBSERVABLE_CREATOR, ObservableCreator } from '../types/observable-creator.symbol';

@Injectable()
export class DynamicFormBuilderService {
  private builder: Builder;

  constructor(
    @Inject(OBSERVABLE_CREATOR) readonly observableCreator: ObservableCreator,
    readonly formBuilder: FormBuilder
  ) {
    this.builder = new Builder(observableCreator, formBuilder);
  }

  build(dataConfig: DataConfiguration, data?: any) {
    return this.builder.build(dataConfig, data) as Observable<AbstractControl | never>;
  }
}
